import {ActionContext, ActionTree} from 'vuex';
import {RootState} from '@/store/type';
import {HttpService} from '@/services/api';
import {ResponseService, Service, ServiceInitState} from '@/store/service/service.types';
import {ServiceEnumApi} from '@/store/service/service.enum';

export const ServiceAction: ActionTree<ServiceInitState, RootState> = {
  async _getService(req: ActionContext<ServiceInitState, RootState>, params?: Service): Promise<void> {
    let {commit} = req;
    try {
      let community = await HttpService.get(ServiceEnumApi.service, params) as { data: ResponseService };
      if (community.data.appCode === 20000) {
        commit('mutationGetService', community.data.data);
      } else {
        commit('mutationGetService', []);
      }
    } catch (e) {
      commit('mutationGetService', []);
      console.error('DEBUG: _getService ', e.message);
    }
  },
  async _insertService(req: ActionContext<ServiceInitState, RootState>, payload: Service): Promise<void> {
    try {
      let {dispatch} = req;
      let res = await HttpService.post(ServiceEnumApi.service, payload);
      await dispatch('_getService');
      return res;
    } catch (e) {
      console.error('DEBUG: _insertService ', e.message);
    }
  },
  async _updateService(req: ActionContext<ServiceInitState, RootState>, payload: Service): Promise<void> {
    try {
      let {dispatch} = req;
      let res = await HttpService.put(ServiceEnumApi.service, payload);
      await dispatch('_getService');
      return res;
    } catch (e) {
      console.error('DEBUG: _updateService ', e.message);
    }
  },
  async _getServiceForRegister(req: ActionContext<ServiceInitState, RootState>, params?: Service): Promise<void> {
    let {commit} = req;
    try {
      let community = await HttpService.get(`${ServiceEnumApi.service}register`, params) as { data: ResponseService };
      if (community.data.appCode === 20000) {
        commit('mutationGetService', community.data.data);
      } else {
        commit('mutationGetService', []);
      }
    } catch (e) {
      commit('mutationGetService', []);
      console.error('DEBUG: _getService ', e.message);
    }
  },

};
